import { DateTime } from 'luxon'

// Ship date of the restructured sidebar. Users created before this date are
// "existing" users (see the sidebar nav announcement); users created on/after
// are "new" users (see Haven's greeting instead) — the two are never shown to
// the same user.
export const SIDEBAR_RESTRUCTURE_ROLLOUT_DATE = '2026-08-21'

export const isNewUserForSidebarRestructure = (
  createdAt: string | null | undefined
) => {
  if (!createdAt) return false
  return (
    DateTime.fromISO(createdAt) >=
    DateTime.fromISO(SIDEBAR_RESTRUCTURE_ROLLOUT_DATE)
  )
}
